import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import classnames from 'classnames';
import React, { useContext } from 'react';

import { useTheme } from '../../../../hooks/useTheme';
import TRANSLATIONS from '../../../../translations/translations@default.json';
import AOWeRecommendSmile from '../../../ProductCard/AOWeRecommendSmile';
import { Context } from '../../store/store';
import Wrapper from './Wrapper';

const FeatureWrapper = ({ product, index }) => {
	const [state] = useContext(Context);
	const { loaded } = state;

	const theme = useTheme('weRecommend');

	const props = {
		top: '-170px',
		left: '-110px',
	};

	return (
		<li
			id={product.Code}
			className={classnames(
				'relative flex flex-col h-full w-full px-1 pb-1 xs:px-2 xs:pb-2 sm:px-4 sm:pb-4 m-2 sm:mx-0 mobileCard__wrapper overflow-hidden rounded',
				theme.background,
				{ 'bg-gray-20': !loaded }
			)}
			style={{ WebkitTransform: 'translateZ(0)' }}>
			<div
				className={classnames(
					'text-title sm:text-title-lg sm:text-white py-2 px-3 sm:px-2',
					{
						[`${theme.text}`]: loaded,
						'text-gray-20': !loaded,
					}
				)}>
				{TRANSLATIONS.productList.productCard.featuredProductFlag}
			</div>

			{loaded && (
				<AOWeRecommendSmile
					className="absolute top-0 weRecommendSmile"
					style={{ ...props }}
					fill={theme.fill}
				/>
			)}
			<Wrapper {...{ product, index, isFeatured: true }} />
		</li>
	);
};

export default FeatureWrapper;
